import React, { useContext, useEffect, useState } from 'react';
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate
} from 'react-router-dom';
import is from 'is_js';
import MainLayout from './MainLayout';

import ErrorLayout from './ErrorLayout';
import Landing from 'components/pages/landing/Landing';
import { toast, ToastContainer } from 'react-toastify';
import { CloseButton } from 'components/common/Toast';

import Error404 from 'components/errors/Error404';
import Error500 from 'components/errors/Error500';

import AppContext from 'context/Context';
import PrivateRoute from 'PrivateRoute';
import Loader from 'components/common/Loader';
import { jwtDecode } from 'jwt-decode';
import { getMonitoringLocations } from 'api/monitoringApi';
import { isEmpty } from 'lodash';
import useApi from 'hooks/useApi';
import { get } from 'lodash';
import { forIn } from 'lodash';
import { getBlockList } from 'api/farmLevelApi';
import BeamDashboard from 'beam/screens/dashboard';
import DistrictReport from 'beam/screens/report';
import Dashboard from 'beam/screens/dashboardnew';
import ReportComponent from 'beam/screens/report';

const Layout = () => {
  const HTMLClassList = document.getElementsByTagName('html')[0].classList;
  const {
    config: { navbarPosition },
    setConfig
  } = useContext(AppContext);

  const { pathname } = useLocation();
  const navigate = useNavigate();
  const isMonitoring = pathname.includes('monitor');
  const isPlotOverlay = pathname.includes('plotoverlay');

  const tokenFromLocalStorage = localStorage.getItem('token');
  const decodedToken = jwtDecode(tokenFromLocalStorage);
  const tenant = decodedToken?.tenant_id;
  const [monitoringLocationData, setMonitoringLocationData] = useState([]);
  const [firstMonitoringCluster, setFirstMonitoringCluster] = useState('');

  // const [monitoringLocationData, setMonitoringLocationData] = useState([]);
  // const [firstMonitoringCluster, setFirstMonitoringCluster] = useState('');

  const getMonitoringLocationAPI = useApi(getMonitoringLocations);
  const getBlockListAPI = useApi(getBlockList);

  const apiHooks = [getMonitoringLocationAPI, getBlockListAPI];

  const performSequentialAPICalls = async () => {
    // setLocationLoading(true);
    for (let i = 0; i < apiHooks.length; i++) {
      await apiHooks[i].request(tenant);
    }
    // setLocationLoading(false);
  };

  useEffect(() => {
    performSequentialAPICalls();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (!isEmpty(getMonitoringLocationAPI.data)) {
        const responseData = get(getMonitoringLocationAPI.data, 'results', {});
        const filterOptions = [];
        forIn(responseData, (value, key) => {
          filterOptions.push({ key, value });
        });
        if (!isEmpty(filterOptions)) {
          const firstClusterKey = filterOptions[0]?.key;
          setFirstMonitoringCluster(firstClusterKey);
          setMonitoringLocationData(filterOptions);
          isMonitoring && setConfig('cluster', firstClusterKey);
        }
      }
      if (!isEmpty(getBlockListAPI.data)) {
        const responseData = get(getBlockListAPI.data, 'results', {});
        const filterOptions = [];
        forIn(responseData, block => {
          filterOptions.push({ key: block.id, value: block.name });
        });
        if (!isEmpty(filterOptions)) {
          const firstClusterKey = filterOptions[0]?.key;
          setFirstMonitoringCluster(firstClusterKey);
          setMonitoringLocationData(filterOptions);
          isPlotOverlay && setConfig('cluster', firstClusterKey);
        }
      }
    };

    fetchData();
  }, [
    getMonitoringLocationAPI.data,
    getBlockListAPI.data,
    isMonitoring,
    isPlotOverlay
  ]);

  useEffect(() => {
    // Extract the tenant from the pathname using a regular expression
    const uuidPattern = /[0-9a-f]{32}/i;
    const match = uuidPattern.exec(pathname);

    if (match) {
      const newTenant = match[0];
      if (tenant !== newTenant) {
        setConfig('tenant', newTenant);
      }
    }
    const newTenant = tenant;

    if (pathname === '/') {
      if (tenant == '29a333e402b4e010610d5783c274c0ed') {
        navigate(`/${newTenant}/dashboardAnalytics`);
      } else {
        navigate(`/${newTenant}/monitor/${firstMonitoringCluster}`);
      }
      // getItemFromStore('tenant', process.env.REACT_APP_DEFAULT_TENANT);
    } else if (pathname === `/${newTenant}/monitor/`) {
      navigate(
        `/${newTenant}/monitor/${
          monitoringLocationData.length > 0
            ? monitoringLocationData[0]?.key
            : firstMonitoringCluster
        }`
      );
    } else if (pathname === `/${newTenant}/plotoverlay/`) {
      navigate(
        `/${newTenant}/plotoverlay/${
          monitoringLocationData.length > 0
            ? monitoringLocationData[0]?.key
            : firstMonitoringCluster
        }`
      );
    }
  }, [pathname, monitoringLocationData, firstMonitoringCluster]);

  useEffect(() => {
    if (is.windows()) {
      HTMLClassList.add('windows');
    }
    if (is.chrome()) {
      HTMLClassList.add('chrome');
    }
    if (is.firefox()) {
      HTMLClassList.add('firefox');
    }
    if (is.safari()) {
      HTMLClassList.add('safari');
    }
  }, [HTMLClassList]);

  useEffect(() => {
    if (navbarPosition === 'double-top') {
      HTMLClassList.add('double-top-nav-layout');
    }
    return () => HTMLClassList.remove('double-top-nav-layout');
  }, [navbarPosition]);

  // Check if the current domain is envira.farmsio.com
  const isDemoDomain = window.location.hostname === 'envira.farmsio.com';

  if (!tenant) {
    return <Loader />;
  }

  return (
    <>
      <Routes>
        <Route path="landing" element={<Landing />} />
        <Route element={<ErrorLayout />}>
          <Route path="errors/404" element={<Error404 />} />
          <Route path="errors/500" element={<Error500 />} />
        </Route>
        {/*- ------------- Authentication ---------------------------  */}

        {/* <Route path="dashboard/dashboard_beam" element={<BeamDashboard />} /> */}

        {/* //--- MainLayout Starts  */}

        <Route path="/" element={<MainLayout />}>
          <Route path={tenant} element={<PrivateRoute />}>
            <Route
              path="dashboard/dashboard_beam"
              element={<BeamDashboard />}
            />
            <Route
              path="district_wise_procurement_report"
              element={<DistrictReport />}
            />
            <Route
              path="state_procurement_dashboard_report_fcs"
              element={
                <ReportComponent
                  key={'state_procurement_dashboard_report_fcs'}
                  keyId={'state_procurement_dashboard_report_fcs'}
                />
              }
            />
            <Route
              path="milling_dispatch_dashboard_report_fcs"
              element={
                <ReportComponent
                  key={'milling_dispatch_dashboard_report_fcs'}
                  keyId={'milling_dispatch_dashboard_report_fcs'}
                />
              }
            />
            <Route
              path="farmer_dashboard_records_fcs"
              element={
                <ReportComponent
                  key={'farmer_dashboard_records_fcs'}
                  keyId={'farmer_dashboard_records_fcs'}
                />
              }
            />
            <Route
              path="infrastructure_dashboard_report_fcs"
              element={
                <ReportComponent
                  key={'infrastructure_dashboard_report_fcs'}
                  keyId={'infrastructure_dashboard_report_fcs'}
                />
              }
            />
            <Route
              path="bonus_summary_fcs_dashboard"
              element={
                <ReportComponent
                  key={'bonus_summary_fcs_dashboard'}
                  keyId={'bonus_summary_fcs_dashboard'}
                />
              }
            />
            <Route path="dashboardAnalytics" element={<Dashboard />} />
          </Route>
        </Route>
        {/* //--- MainLayout end  */}

        {/* <Navigate to="/errors/404" /> */}
        <Route path="*" element={<Navigate to="/errors/404" replace />} />
      </Routes>
      <ToastContainer
        closeButton={CloseButton}
        icon={false}
        position={toast.POSITION.BOTTOM_RIGHT}
      />
    </>
  );
};

export default Layout;
